type DebouncedFunction<T extends (...args: any[]) => any> = ((
	...args: Parameters<T>
) => void) & {
	cancel: () => void;
};

export const debounce = <T extends (...args: any[]) => any>(
	callback: T,
	waitFor = 500,
): DebouncedFunction<T> => {
	let timeout: ReturnType<typeof setTimeout> | null = null;
	const debounced = ((...args: Parameters<T>) => {
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(() => {
			timeout = null;
			callback(...args);
		}, waitFor);
	}) as DebouncedFunction<T>;

	debounced.cancel = () => {
		if (timeout) clearTimeout(timeout);
		timeout = null;
	};

	return debounced;
};
